'use client';

import {Banner} from '@/components/common';
import MyTabGroup from '@/components/my/common/group/TabGroup';
import {ROUTE} from '@/constants/main/route';
import {Outlet, useLocation} from 'react-router-dom';
import '/public/static/css/module/depth2Menu.scss';
import useGlobalUIStore from '@/stores';
import {sendWebUvLog} from '@/utils/main';

const TABS = [
  {
    name: '최근 본 스트리머의 LIVE',
    route: ROUTE.MY.HISTORY.RECENT.INDEX,
  },
  {
    name: '최근 본 VOD',
    route: ROUTE.MY.HISTORY.RECENT.VOD,
  },
  {
    name: '나중에 보기',
    route: ROUTE.MY.HISTORY.LATER,
  },
  {
    name: 'UP한 VOD',
    route: ROUTE.MY.HISTORY.UP,
  },
  {
    name: '재생목록',
    route: ROUTE.MY.HISTORY.PLAYLIST,
  },
];

/**
 * /my/history 경로 한정 레이아웃
 * @param {React.ReactNode} 페이지
 * @returns {JSX.Element} 페이지 레이아웃
 */
const MyLayout = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const {setRefreshTimestamp} = useGlobalUIStore();

  /**
   * 탭 클릭 이벤트 핸들러
   * @description 현재 경로와 동일한 탭 클릭 시 children 을 리렌더 후 uv log 를 보낸다
   * @param {string} toPath
   */
  const handleTabClicked = (event, toPath) => {
    if (window.location.pathname === toPath) {
      setRefreshTimestamp();
      sendWebUvLog();
      event.preventDefault();
    }
  };

  return (
    <>
      {pathname !== '/my/history/story' && (
        <MyTabGroup
          tabs={TABS}
          type='flat'
          handleLinkClicked={handleTabClicked}
        />
      )}
      <Banner type={'sub'} category={'history'} />
      <Outlet />
    </>
  );
};

export default MyLayout;
